import { render, staticRenderFns } from "./shopManager.vue?vue&type=template&id=535fe5d2&scoped=true&"
import script from "./shopManager.vue?vue&type=script&lang=js&"
export * from "./shopManager.vue?vue&type=script&lang=js&"
import style0 from "./shopManager.vue?vue&type=style&index=0&id=535fe5d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535fe5d2",
  null
  
)

export default component.exports